module.exports = __webpack_public_path__ + "img/logo.226efdb8.webp";